import { ComputedRef, Ref, computed } from 'vue';
import { getRangeStepSpan } from '@/ts/util/util';
import { CALCULATOR_PERIOD_MAP } from '@/ts/constants/predefinedCalculatorRanges';
import { CalculatorKey } from '@/ts/composables/useCalculator';

const COLOR_SCALE_STEP_COUNT = 9;

// Factory for creating instance-scoped range state
export function createRange(dependencies: {
  period: ComputedRef<number>;
  calculatorKey: Ref<CalculatorKey>;
}) {
  const range = computed<[number, number]>(() => {
    const periodToRange = CALCULATOR_PERIOD_MAP[dependencies.calculatorKey.value].find(([calcPeriod], i) => { // find the range that is closest to the current period
      if (calcPeriod === dependencies.period.value)
        return true;

      const nextElement = CALCULATOR_PERIOD_MAP[dependencies.calculatorKey.value][i + 1];
      if (nextElement === undefined)
        return true;
      const nextPeriod = nextElement[0];
      const average = (calcPeriod + nextPeriod) / 2;
      const isCloserToCurrentPeriod = average - dependencies.period.value >= 0;
      return isCloserToCurrentPeriod;
    });

    return periodToRange ? periodToRange[1] : CALCULATOR_PERIOD_MAP[dependencies.calculatorKey.value][0][1]; // this safety return should never happen
  });

  const numericSteps = computed(() => {
    return getRangeStepSpan(range.value, COLOR_SCALE_STEP_COUNT);
  });

  return { range, numericSteps };
}
